<template>
  <transition name="scale">
    <div class="project-preview" v-if="this.$root.previewedProject !== null">
      <div class="relative-wrap">
        <div class="scrollable-wrap">
          <div class="full-height-wrap">
            <div class="info">
              <div class="basic-info">
                <span class="name">
                  {{ $root.previewedProject.project.title }}
                </span>
                <span class="description">
                  {{ $root.previewedProject.project.description }}
                </span>
              </div>
              <div class="team">
                <div
                  class="participant"
                  v-for="(participant, index) in this.$root.previewedProject.project.developers"
                  :key="index"
                >
                  <span class="role">
                    {{ participant.role }}
                  </span>
                  <span class="name">
                    {{ participant.name }}
                  </span>
                </div>
              </div>
            </div>
            <div class="images">
              <img
                v-for="index in this.$root.previewedProject.project.imageCount"
                :key="index"
                :src="`/images/portfolio/${encodeURIComponent($root.previewedProject.name)}/desktop-${index}.jpg`"
                :srcset="`
                  /images/portfolio/${encodeURIComponent($root.previewedProject.name)}/desktop-${index}.jpg 1x,
                  /images/portfolio/${encodeURIComponent($root.previewedProject.name)}/desktop-${index}@2x.jpg 2x
                `"
              >
            </div>
          </div>
        </div>
        <div class="close" @click="hidePreview">
          <img src="../assets/images/close.svg" alt="Закрыть">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'ProjectPreview',

    methods: {
      hidePreview() {
        this.$root.previewedProject = null;
      }
    }
  };
</script>

<style lang="less" scoped>
  @import (reference) '../shared.less';

  .project-preview {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: @colors[background];
    z-index: @z-layers[project-preview];
    overflow-y: scroll;
    display: flex;
  }

  .scale-enter-active,
  .scale-leave-active {
    transition-property: transform, opacity;
    transition-duration: @transition-durations[main-block];
    transition-timing-function: @easing-functions[ease-out-cubic];

    [prefers-reduced-motion] & {
      transition-property: opacity;
    }
  }

  .scale-enter,
  .scale-leave-to {
    transform: scale(0);
    opacity: 0;

    [prefers-reduced-motion] & {
      transform: unset;
    }
  }

  .scale-enter-to,
  .scale-leave {
    transform: scale(1);
    opacity: 1;

    [prefers-reduced-motion] & {
      transform: unset;
    }
  }

  .relative-wrap {
    position: relative;
    flex-grow: 1;
    display: flex;
  }

  .scrollable-wrap {
    -webkit-overflow-scrolling: touch;
    flex-grow: 1;
    overflow-y: scroll;
    .hide-scrollbar();
  }

  .full-height-wrap {
    margin: @margins[long-v-padding] @margins[long-h-padding];
    display: flex;
    flex-direction: column;

    @media @vertical {
      margin: @margins-v[long-v-padding] @margins-v[long-h-padding];
    }

    @media @mobile {
      margin: @margins-m[long-v-padding] @margins-m[long-h-padding];
    }

    @media @mobile-vertical {
      margin: @margins-mv[long-v-padding] @margins-mv[long-v-padding];
    }
  }

  .info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    @media @vertical {
      flex-direction: column;
      align-items: flex-start;
    }

    @media @mobile-vertical {
      padding-right: @margins-mv[long-h-padding] * 3;
    }
  }

  @info-bottom-margin: 4vh;
  .info-bottom-margin {
    margin-bottom: @info-bottom-margin;

    @media @vertical {
      margin-bottom: unset;
    }
  }

  .basic-info {
    display: flex;
    align-items: center;
    margin-right: 8vh;
    .info-bottom-margin();

    @media @vertical {
      flex-direction: column;
      align-items: flex-start;
      margin-right: unset;
    }

    .name {
      font-size: 4vh;
      font-family: @font-sets[header];
      font-weight: @font-weights[semibold];
      white-space: nowrap;

      @media @vertical {
        font-size: 4vw;
      }

      @media @mobile {
        font-size: @font-sizes-m[header] / 2;
      }

      @media @mobile-vertical {
        font-size: @font-sizes-mv[header] / 2;
      }
    }

    .description {
      margin-left: 8vh;
      flex-basis: 32vh;
      color: @colors[soft];

      @media @vertical {
        margin-left: unset;
        flex-basis: unset;
      }

      @media @mobile {
        flex-basis: unset;
      }
    }
  }

  .team {
    display: flex;
    .info-bottom-margin();

    @media @vertical {
      margin-top: 4vw;
    }

    @media @mobile {
      flex-wrap: wrap;
    }
  }

  .participant {
    display: flex;
    flex-direction: column;

    &+& {
      margin-left: 4vh;

      @media @vertical {
        margin-left: 4vw;
      }

      @media @mobile {
        margin-left: unset;
      }
    }

    &:not(:last-child) {
      @media @mobile {
        margin-right: 4vh;
      }
    }

    .role {
      color: @colors[soft];

      @media @mobile {
        margin-top: 2vh;
      }
    }

    .name {
      font-size: 2.5vh;
      white-space: nowrap;

      @media @vertical {
        margin-top: unset ;
        font-size: 2.5vw;
      }

      @media @mobile {
        font-size: @font-sizes-m[normal];
        margin-top: unset;
      }

      @media @mobile-vertical {
        font-size: @font-sizes-mv[normal];
      }
    }
  }

  .images {
    margin-top: @margins[long-v-padding] - @info-bottom-margin;

    @media @vertical {
      margin-top: @margins-v[long-v-padding];
    }

    img {
      max-width: 100%;
      display: block;
    }

    img+img {
      margin-top: @margins[long-v-padding];

      @media @vertical {
        margin-top: @margins-v[long-v-padding];
      }
    }

  }

  .close {
    @button-size: @margins[long-h-padding];
    @button-size-v: @margins-v[long-h-padding] * 1.5;
    @button-size-m: @margins-m[long-h-padding] * 2.5;
    @button-size-mv: @margins-mv[long-h-padding] * 3;

    position: absolute;
    top: 0;
    right: 0;
    width: @button-size;
    height: @button-size;
    cursor: pointer;
    background-color: @colors[background];
    display: flex;
    justify-content: center;
    align-items: center;

    @media @vertical {
      width: unset;
      height: unset;
      margin: @margins-v[long-v-padding] @margins-v[long-h-padding];
    }

    @media @mobile {
      width: @button-size-m;
      height: @button-size-m;
    }

    @media @mobile-vertical {
      width: @button-size-mv;
      height: @button-size-mv;
      margin: @margins-mv[long-v-padding] @margins-mv[long-h-padding];
    }

    img {
      @img-size: @button-size / 2;

      width: @img-size;
      height: @img-size;
      transition: filter 0.2s linear;
      filter: brightness(100%);

      @media @vertical {
        @img-size-v: @button-size-v / 2;

        width: @img-size-v;
        height: @img-size-v;
      }

      @media @mobile {
        @img-size-m: @button-size-m / 2;

        width: @img-size-m;
        height: @img-size-m;
      }

      @media @mobile-vertical {
        @img-size-mv: @button-size-mv / 2;

        width: @img-size-mv;
        height: @img-size-mv;
      }
    }

    &:hover img {
      filter: brightness(400%);
    }
  }
</style>
